import { useTranslation } from "react-i18next";
import { getQuestionTypes, QuestionTypeCategory } from "../../../api/main/models/codeOnly/QuestionType";
import { QuestionsListBase } from "../QuestionsListBase";

/**
 * List of learning activities.
 */
export const LearningList = () => {
    const { t } = useTranslation();

    return (
        <QuestionsListBase
            title={t('learningList.title', 'Learning activities')}
            questionTypeColumnName={t('learningList.questionTypeColumnName', 'Type of learning')}
            questionTypes={getQuestionTypes(QuestionTypeCategory.Learning)}
            baseRoute={'/administration/learning-activities'}
        />
    );
};